import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { FailedBatchAction, getKeyForHold } from "./HoldsSharedView";

export interface HoldsBatchErrorDialogProps {
  failedBatchAction: FailedBatchAction;
  onClose: (successes: number) => void;
}

export const HoldsBatchErrorDialog: React.FC<HoldsBatchErrorDialogProps> = ({
  failedBatchAction,
  onClose,
}) => {
  const { translate } = useLanguage();
  return (
    <Dialog
      open={!!failedBatchAction}
      onClose={() => onClose(failedBatchAction.successCount)}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          {failedBatchAction?.failedHolds.length}{" "}
          {failedBatchAction?.actionType === "cancel"
            ? translate("cancelHoldFailureMessage")
            : translate("reactivateHoldsErrorMessage")}
        </Alert>
        <List disablePadding>
          {failedBatchAction?.failedHolds.map((hold, index) => (
            <ListItem key={getKeyForHold(hold)} disableGutters>
              <Typography variant="body1">
                {index + 1}. {hold.title}{" "}
                {hold.resource?.shortAuthor &&
                  `by ${hold.resource.shortAuthor}`}
              </Typography>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(failedBatchAction.successCount)}>
          {translate("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
